import { NamedId } from "../Models/NamedId";
import { CustomerRoles } from "./Constants";

// English Dictionary for storing all the verbiage for the Customer Portal.
export const englishDictionary: { [key: string]: string; } = {
  'tabTitle': 'Customer Portal',
  'validatingLinkTitle': 'Validating Link',
  'validatingLinkMessage': 'Validating your link. Just a moment...',
  'thanks': 'Thanks for submitting your application at our ',
  'thankyou': 'Thank you',
  'thanksContinued': 'store! We just need a few more things to get you approved.',
  'application': 'Application',
  'appReceived': 'Application Received',
  'stipulations': 'Stipulations',
  'documents': 'Documents',
  'addDocuments': 'Add Documents',
  'references': 'References',
  'addReference': 'Add Reference',
  'addReferences': 'Add References',
  'login': 'Login',
  'signInTitle': 'Sign in to continue',
  'signInToContinue': 'Please sign in to continue your application.',
  'confirmSocial': 'Confirm Social Security Number',
  'loginWithSocial': 'Login with Social Security Number',
  'loginDifferentWay': 'Login a different way',
  'loginWithNameAndBirthday': 'Login with Name & Birthday',
  'requestLinkSuccessTitle': 'Request Submitted',
  'requestLinkSuccessMessage': 'Thank you for submitting your request. We will be in contact with you soon with a new link.',
  'questionsCallUs': 'Questions? Call us at',
  'lastFourDescription': 'Enter last four digits of your social security number.',
  'ssnPlaceholder': 'SSN...',
  'confirm': 'Confirm',
  'loggingIn': 'Logging in...',
  'year': 'Year',
  'month': 'Month',
  'day': 'Day',
  'confirmNameBirthday': 'Confirm Name and Birthday',
  'enterNameBirthday': 'Enter your last name and date of birth.',
  'name': 'Name',
  'lastName': 'Last Name',
  'relationship': 'Relationship',
  'email': 'Email',
  'homePhone': 'Home Phone',
  'cellPhone': 'Cell Phone',
  'address': 'Address',
  'storeAddress': 'Store Address',
  'city': 'City',
  'state': 'State',
  'zipCode': 'Zip Code',
  'notes': 'Notes',
  'callable': 'Can Be Called?',
  'dateOfBirth': 'Date of Birth',
  'uploadDocsTitle': 'Upload Documents',
  'uploadDocsDescription': 'Upload some documents for each of the following categories. Please bring the original documents to your appointment at ',
  'uploadingDocs': 'Uploading Documents...',
  'proofOfIncome': 'Proof of Income',
  'proofOfResidence': 'Proof of Residence',
  'photoId': 'Photo ID',
  'additionalDocuments': 'Additional Documents',
  'additionalDocumentsDescription': 'Upload any additional documents you would like us to consider towards your approval.',
  'cannotDeleteDocs': 'Once the document is uploaded it can’t be deleted',
  'proofOfIncomeExamples': 'Recent Paycheck, Award Letter, Bank Statement',
  'proofOfResidenceExamples': 'Copy of lease/mortgage',
  'photoIdExamples': 'Driver\'s License, State-issued photo ID',
  'complete': 'Complete',
  'optional': 'Optional',
  'upload': 'Upload',
  'submittedDocuments': 'Submitted Documents',
  'acceptableDocs': 'Acceptable Documents',
  'viewPdf': 'View PDF',
  'invalidExtensions': 'One of these files is an invalid type. Valid types are: .png, .jpg, .jpeg, .pdf',
  'docAlreadyUploaded': 'You\'ve already uploaded this document for this category.',
  'document': 'document',
  'documentType': 'Document Type',
  'type': 'Type',
  'save': 'Save',
  'cancel': 'Cancel',
  'remove': 'Remove',
  'yes': 'Yes',
  'no': 'No',
  'create': 'Create',
  'edit': 'Edit',
  'confirmRemoval': 'Do you want to remove this?',
  'willContact': 'We\'ll contact you soon to go over the next steps.',
  'changeLanguage': 'Change Language',
  'preferredLanguage': 'Preferred Language',
  'incorrectLoginMessage': 'Incorrect login information. Please try again.',
  'loginErrorMessage': 'We ran into an issue while logging you in. Please try again.',
  'requestLinkErrorMessage': 'We ran into an issue while handling your request. Please try again.',
  'minLoginAttempsExceeded': 'You have exceeded the maximum number of login attempts. We will need to send you a new link.',
  'pickDate': 'Pick a date',
  'pickTime': 'Pick a time',
  'confirmAppt': 'Confirm Appointment',
  'confirmApptDesc': 'You are scheduling an appointment at ',
  'confimApptDescContinued': 'Do you want to confirm this appointment?',
  'callUs': 'Questions? Call us at',
  'scheduleApptTitle': 'Schedule Appointment',
  'upcomingApptTitle': 'Upcoming Appointment',
  'apptTitle': 'Appointment',
  'makeAppt': 'Make Appointment',
  'viewAppt': 'View Appointment',
  'apptDescription': 'Choose a date and time to schedule an appointment with ',
  'apptDescriptionContinued': ' at ',
  'apptQuestionsDescription': 'Questions? Call us at ',
  'apptScheduledDesc': 'You have an appointment scheduled',
  'apptScheduling': 'Scheduling your appointment...',
  'when': 'When',
  'where': 'Where',
  'with': 'With',
  'at': 'at',
  'liveswithcustomer': 'Lives with you',
  'liveswithcustomerquestion': 'Lives with you?',
  'requestingNewLink': 'Requesting new link...',
  'requestLink': 'Request New Link',
  'invalidLinkTitle': 'Invalid or Expired Link',
  'invalidOrExpiredLink': 'This link is invalid or has expired. Please request a new link.',
  'needed': 'needed',
  'types': 'Type',
  'minimumReferencesMessage': 'Please upload ',
  'minimumReferencesMessageContinued': ' more reference(s).',
  'selectDocumentType': 'Select a type for this document',
  'closedOnSundays': 'We\'re closed on Sundays!',
  'needMoreInfo': 'We need more information.\n\nEnter your last name and date of birth.',
  'requiredFields': '* indicates required field',
  'scheduleApptBtn': 'Schedule Appointment',
  'openInMaps': 'Open in maps',
  'prequalificationcomplete': 'Pre-qualification complete!',
  'forcompletingprequalification': 'for completing your pre-qualification request',
  'yourscoreisinrange': 'Your score is within the range',
  'ourteamwillbeintouch': 'Our team will be in touch with you shortly to discuss your options',
  'thanksforinterest': 'Thank you for your interest. We received your information and someone from ',
  'willbeincontact': 'will be in contact with you shortly to work out a loan program',
  'filloutcreditapp': 'Click here to begin filling out your full credit application',
  'loadingprequalification': 'Loading Pre-Qualification',
};

export const englishStipulationCategoryDictionary: { [key: string]: string; } = {
  'proof of valid in-state driver\'s license': 'Proof of valid in-State Driver\'s License',
  'proof of residence': 'Proof of residence',
  'proof of stable income': 'Proof of stable income',
  'proof of valid id': 'Proof of valid ID',
  'proof of insurance on the vehicle': 'Proof Of Insurance On The Vehicle',
  'references who can verify job and residence': 'References Who Can Verify Job And Residence',
};

export const englishDocumentTypeDictionary: { [key: string]: string; } = {
  'confirmation letter': 'Confirmation letter',
  'driver\'s License': 'Driver\'s License',
  'driver\'s License 2': 'Driver\'s License 2',
  'employer verification': 'Employer Verification',
  'insurance binder': 'CPI Insurance binder',
  'insurance card': 'Insurance card',
  'insurance policy': 'Insurance policy',
  'landlord verification': 'Landlord verification',
  'landord verification': 'Landlord verification', // portential misspelling in our DB record
  'lease': 'Lease',
  'name & number': 'Name & number',
  'paystubs': 'Paystubs',
  'tax documentation': 'Tax Documentation',
  'current utility bill': 'Current utility bill',
  'bank statement': 'Bank statement',
  'bank statements': 'Bank statements',
};

export const englishReferenceRelationshipDictionary: { [key: string]: string; } = {
  'bank': 'Bank',
  'brother': 'Brother',
  'contract': 'Contract',
  'consumer finance': 'Consumer Finance',
  'credit card': 'Credit Card',
  'credit union': 'Credit Union',
  'daughter': 'Daughter',
  'employer': 'Employer',
  'father': 'Father',
  'friend': 'Friend',
  'landlord': 'Landlord',
  'mortgage': 'Mortgage',
  'mother': 'Mother',
  'neighbor': 'Neighbor',
  'not applicable': 'Not Applicable',
  'other': 'Other',
  'other relative': 'Other Relative',
  'personal': 'Personal',
  'retail': 'Retail',
  'sister': 'Sister',
  'son': 'Son',
  'spouse': 'Spouse',
  'will call': 'Will Call',
};

export const englishMonths: NamedId[] = [
  { id: '1', name: 'January' },
  { id: '2', name: 'February' },
  { id: '3', name: 'March' },
  { id: '4', name: 'April' },
  { id: '5', name: 'May' },
  { id: '6', name: 'June' },
  { id: '7', name: 'July' },
  { id: '8', name: 'August' },
  { id: '9', name: 'September' },
  { id: '10', name: 'October' },
  { id: '11', name: 'November' },
  { id: '12', name: 'December' },
];

// Spanish Dictionary for storing all the verbiage for the Customer Portal.
export const spanishDictionary: { [key: string]: string; } = {
  'tabTitle': 'Portal del Cliente',
  'validatingLinkTitle': 'Validando enlace',
  'validatingLinkMessage': 'Validando su enlace. Solo un momento...',
  'thanks': '¡Gracias por enviar su aplicacion en nuestra ',
  'thankyou': 'Gracias',
  'thanksContinued': 'tienda! Solo necesitamos algunas cosas más para que lo aprueben.',
  'application': 'Aplicacion',
  'appReceived': 'Aplicacion Recibida',
  'stipulations': 'Tipos de verificacion',
  'documents': 'Documentos',
  'addDocuments': 'Agregar Documentos',
  'references': 'Referencias',
  'addReference': 'Agregar Referencia',
  'addReferences': 'Agregar Referencias',
  'login': 'Iniciar sesión',
  'signInTitle': 'Inicie sesión para continuar',
  'signInToContinue': 'Por favor inicie sesion para continuar su aplicacion.',
  'confirmSocial': 'Confirmar Número de Seguro Social',
  'loginWithSocial': 'Iniciar sesión con el número de seguro social',
  'loginDifferentWay': 'Iniciar sesión de otra manera',
  'loginWithNameAndBirthday': 'Iniciar sesión con nombre y cumpleaños',
  'requestLinkSuccessTitle': 'Solicitud enviada',
  'requestLinkSuccessMessage': 'Gracias por enviar su solicitud. Nos pondremos en contacto con usted pronto con un nuevo enlace.',
  'questionsCallUs': '¿Preguntas? Llámenos al',
  'lastFourDescription': 'Ultimo cuatro nymeros de su numero de seguro social.',
  'ssnPlaceholder': 'SSN...',
  'confirm': 'Confirmar',
  'loggingIn': 'Iniciando sesión...',
  'year': 'Año',
  'month': 'Mes',
  'day': 'Día',
  'confirmNameBirthday': 'Confirmar nombre y cumpleaños',
  'enterNameBirthday': 'Ingrese su apellido y fecha de nacimiento.',
  'name': 'Nombre',
  'lastName': 'Apellido',
  'relationship': 'Relación',
  'email': 'Correo electrónico',
  'homePhone': 'Teléfono de casa',
  'cellPhone': 'Celular',
  'address': 'Dirección',
  'storeAddress': 'Dirección de la tienda',
  'city': 'Ciudad',
  'state': 'Estado',
  'zipCode': 'Código postal',
  'notes': 'Notas',
  'callable': '¿Se puede llamar?',
  'dateOfBirth': 'Cumpleaños',
  'uploadDocsTitle': 'Enviar documentos',
  'uploadDocsDescription': 'Cargue algunos documentos para cada una de las siguientes categorías. Favor de presentar los documentos originales al momento de su visita a ',
  'uploadingDocs': 'Cargando documentos...',
  'proofOfIncome': 'Verificacion de ingreso',
  'proofOfResidence': 'Verificacion de residencia',
  'photoId': 'Identificación con foto',
  'additionalDocuments': 'Documentos adicionales',
  'additionalDocumentsDescription': 'Cargue cualquier documento adicional que desee que consideremos para su aprobación.',
  'cannotDeleteDocs': 'Una vez subido el documento no puede ser removido',
  'proofOfIncomeExamples': 'Cheque de pago reciente, carta de adjudicación, estado de cuenta bancaria',
  'proofOfResidenceExamples': 'Copia del contrato de arrendamiento / hipoteca',
  'photoIdExamples': 'Licencia de conducir, identificación con foto emitida por el estado',
  'complete': 'Terminar',
  'optional': 'Opcional',
  'upload': 'Enviar',
  'submittedDocuments': 'Documentos enviados',
  'acceptableDocs': 'Documentos aceptables',
  'viewPdf': 'Ver PDF',
  'invalidExtensions': 'Uno de estos archivos es un tipo inválido. Los tipos válidos son: .png, .jpg, .jpeg, .pdf',
  'docAlreadyUploaded': 'Ya ha subido este documento para esta categoría.',
  'document': 'documento',
  'documentType': 'Tipo de documento',
  'type': 'Tipo',
  'save': 'Guardar',
  'cancel': 'Cancelar',
  'remove': 'Eliminar',
  'yes': 'Sí',
  'no': 'No',
  'create': 'Crear',
  'edit': 'Editar',
  'confirmRemoval': '¿Quieres eliminar esto?',
  'willContact': 'Nos pondremos en contacto pronto para repasar los siguientes pasos.',
  'changeLanguage': 'Cambiar idioma',
  'preferredLanguage': 'Idioma preferido',
  'incorrectLoginMessage': 'Información de inicio de sesión incorrecta. Por favor, inténtelo de nuevo.',
  'loginErrorMessage': 'Nos encontramos con un problema al iniciar sesión. Por favor, inténtelo de nuevo.',
  'requestLinkErrorMessage': 'Nos encontramos con un problema al manejar su solicitud. Por favor, inténtelo de nuevo.',
  'minLoginAttempsExceeded': 'Ha excedido el número máximo de intentos de inicio de sesión. Tendremos que enviarle un nuevo enlace.',
  'pickDate': 'Elija una fecha',
  'pickTime': 'Elija una hora',
  'confirmAppt': 'Confirmar cita',
  'confirmApptDesc': 'Está programando una cita en ',
  'confimApptDescContinued': '¿Quiere confirmar esta cita?',
  'callUs': '¿Preguntas? Llámenos al',
  'apptTitle': 'Cita',
  'makeAppt': 'Hacer cita',
  'viewAppt': 'Ver cita',
  'scheduleApptTitle': 'Programar cita',
  'upcomingApptTitle': 'Cita próxima',
  'apptDescription': 'Elija una fecha y hora para programar una cita con ',
  'apptDescriptionContinued': ' en ',
  'apptQuestionsDescription': '¿Preguntas? Llámenos al ',
  'apptScheduledDesc': 'Tiene una cita programada ',
  'apptScheduling': 'Programando su cita...',
  'when': 'Cuando',
  'where': 'Donde',
  'with': 'Con',
  'at': 'a las',
  'liveswithcustomer': 'Vive contigo',
  'liveswithcustomerquestion': '¿Vive contigo?',
  'requestingNewLink': 'Solicitando nuevo enlace...',
  'requestLink': 'Solicitar nuevo enlace',
  'invalidLinkTitle': 'Enlace no válido o caducado',
  'invalidOrExpiredLink': 'Este enlace no es válido o ha caducado. Solicite un nuevo enlace.',
  'needed': 'necesario',
  'types': 'Tipo',
  'minimumReferencesMessage': 'Por favor suba ',
  'minimumReferencesMessageContinued': ' referencias má(s).',
  'selectDocumentType': 'Seleccione un tipo para este documento',
  'closedOnSundays': '¡Estamos cerrados los domingos!',
  'needMoreInfo': 'Necesitamos más información para continuar. Ingrese su apellido y fecha de nacimiento.',
  'requiredFields': '* indica campo requerido',
  'scheduleApptBtn': 'Programar cita',
  'openInMaps': 'Abrir en mapas',
  'prequalificationcomplete': '¡La precalificación está completa!',
  'forcompletingprequalification': 'por completar su solicitud de precalificación',
  'yourscoreisinrange': 'Su puntaje está dentro del rango',
  'ourteamwillbeintouch': 'Nuestro equipo se pondrá en contacto con usted pronto para discutir sus opciones',
  'thanksforinterest': 'Gracias por su interés. Hemos recibido su información y alguien de ',
  'willbeincontact': 'se pondrá en contacto con usted pronto para trabajar en un programa de préstamo',
  'filloutcreditapp': 'Haga clic aquí para comenzar a completar su solicitud de crédito completa',
  'loadingprequalification': 'Cargando Pre-Calificación',
};

export const spanishStipulationCategoryDictionary: { [key: string]: string; } = {
  'proof of valid in-state driver\'s license': 'Licencia estatal de conducir',
  'proof of residence': 'Prueba de residencia',
  'proof of stable income': 'Prueba de ingresos estable',
  'proof of valid id': 'Prueba de identificación válida',
  'proof of insurance on the vehicle': 'Prueba de seguro en el vehículo',
  'references who can verify job and residence': 'Referencias que pueden verificar trabajo y residencia',
};

export const spanishDocumentTypeDictionary: { [key: string]: string; } = {
  'confirmation letter': 'Carta de confirmación',
  'driver\'s License': 'Licencia de conducir',
  'driver\'s License 2': 'Licencia de conducir 2',
  'employer verification': 'Verificacion de empleo',
  'insurance card': 'Tarjeta de seguro',
  'insurance policy': 'Póliza de seguro',
  'landlord verification': 'Verificación de propietario',
  'landord verification': 'Verificación de propietario', // portential misspelling in our DB record
  'lease': 'Arrendamiento',
  'name & number': 'Nombre y número',
  'paystubs': 'Talonario de ingreso',
  'tax documentation': 'Documento de impuestos',
  'current utility bill': 'Factura de utilidad',
  'bank statement': 'Estado de cuenta bancaria',
  'bank statements': 'Estados de cuenta bancaria',
};

export const spanishReferenceRelationshipDictionary: { [key: string]: string; } = {
  'bank': 'Banco',
  'brother': 'Hermano',
  'consumer finance': 'Credito del consumo',
  'contract': 'Contrato',
  'credit card': 'Tarjeta de crédito',
  'credit union': 'Cooperativa',
  'daughter': 'Hija',
  'employer': 'Empleador',
  'father': 'Padre',
  'friend': 'Amigo',
  'landlord': 'Propietario',
  'mortgage': 'Hipoteca',
  'mother': 'Madre',
  'neighbor': 'Vecino',
  'not applicable': 'No Aplica',
  'other': 'Otro',
  'other relative': 'Otro pariente',
  'personal': 'Personal',
  'retail': 'Comercio',
  'son': 'Hijo',
  'spouse': 'Conyuge',
  'sister': 'Hermana',
  'will call': 'Llamada',
};

export const spanishMonthsDictionary: NamedId[] = [
  { id: '1', name: 'Enero' },
  { id: '2', name: 'Febrero' },
  { id: '3', name: 'Marzo' },
  { id: '4', name: 'Abril' },
  { id: '5', name: 'Mayo' },
  { id: '6', name: 'Junio' },
  { id: '7', name: 'Julio' },
  { id: '8', name: 'Agosto' },
  { id: '9', name: 'Septiembre' },
  { id: '10', name: 'Octubre' },
  { id: '11', name: 'Noviembre' },
  { id: '12', name: 'Diciembre' },
];

// Gets the dictionary item based on the key and language.
export const getWordingForLanguage = (key: string, languageId: string) => {
  if (languageId === '1') {
    return englishDictionary[key] ?? key;
  } else if (languageId === '2') {
    return spanishDictionary[key] ?? key;
  } else {
    // default to english if no language is found.
    return englishDictionary[key] ?? key;
  }
}

// Gets the stipulation category item based on the key and language.
export const getStipulationCategoryForLanguage = (key: string, languageId: string) => {
  if (languageId === '1') {
    return englishStipulationCategoryDictionary[key] ?? key;
  } else if (languageId === '2') {
    return spanishStipulationCategoryDictionary[key] ?? key;
  } else {
    // default to english if no language is found.
    return englishStipulationCategoryDictionary[key] ?? key;
  }
}

// Gets the document type item based on the key and language.
export const getDocumentTypeForLanguage = (key: string, languageId: string) => {
  if (languageId === '1') {
    return englishDocumentTypeDictionary[key] ?? key
  } else if (languageId === '2') {
    return spanishDocumentTypeDictionary[key] ?? key;
  } else {
    // default to english if no language is found.
    return englishDocumentTypeDictionary[key] ?? key;
  }
}

// Gets the reference relationship item based on the key and language.
export const getReferenceRelationshipForLanguage = (key: string, languageId: string) => {
  if (languageId === '1') {
    return englishReferenceRelationshipDictionary[key] ?? key;
  } else if (languageId === '2') {
    return spanishReferenceRelationshipDictionary[key] ?? key;
  } else {
    // default to english if no language is found.
    return englishReferenceRelationshipDictionary[key] ?? key;
  }
}

export const getMonthsForLanguage = (languageId: string): NamedId[] => {
  if (languageId === '1') {
    return englishMonths;
  } else if (languageId === '2') {
    return spanishMonthsDictionary;
  } else {
    // default to english if no language is found.
    return englishMonths;
  }
}

// returns the customer role name in the specified language for the role ID. Role IDs are:
export const getCustomerRoleName = (roleId: string, languageId: string): string => {
  if (roleId.toLowerCase() === CustomerRoles.applicant.toLowerCase()) {
    return languageId === '1' ? 'Applicant' : 'Solicitante';
  } else if (roleId.toLowerCase() === CustomerRoles.coApplicant.toLowerCase()) {
    return languageId === '1' ? 'Co-Buyer 1' : 'Co-Comprador 1';
  } else if (roleId.toLowerCase() === CustomerRoles.coApplicant2.toLowerCase()) {
    return languageId === '1' ? 'Co-Buyer 2' : 'Co-Comprador 2';
  } else {
    return '';
  }
}
